import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import Icon from '../AppIcon';
import BarcodeScanner from './BarcodeScanner';

/**
 * Pulsante "Scansiona" che apre lo scanner a schermo intero (fotocamera + inserimento manuale).
 * onRilevato(codice) riceve il codice letto o digitato; lo scanner si chiude da solo.
 *
 * variante: 'testo' (pulsante con etichetta) | 'icona' (solo icona, per dentro un campo di ricerca)
 */
const PulsanteScanner = ({
  onRilevato,
  etichetta = 'Scansiona',
  titolo,
  variante = 'testo',
  disabilitato = false,
  className = '',
  formati,
}) => {
  const [aperto, setAperto] = useState(false);

  return (
    <>
      {variante === 'icona' ? (
        <button
          type="button"
          onClick={() => setAperto(true)}
          disabled={disabilitato}
          aria-label={etichetta}
          title={etichetta}
          className={`w-8 h-8 rounded-xl bg-primary/10 hover:bg-primary hover:text-primary-foreground border border-primary/20 text-primary flex items-center justify-center transition-all disabled:opacity-50 ${className}`}
        >
          <Icon name="ScanBarcode" size={16} />
        </button>
      ) : (
        <button
          type="button"
          onClick={() => setAperto(true)}
          disabled={disabilitato}
          className={`flex items-center justify-center gap-2 px-4 py-3 rounded-2xl border bg-primary/10 border-primary/30 text-primary hover:bg-primary/20 text-[10px] font-black uppercase tracking-widest transition-all disabled:opacity-50 whitespace-nowrap ${className}`}
        >
          <Icon name="ScanBarcode" size={14} />
          {etichetta}
        </button>
      )}

      {aperto && createPortal(
        <BarcodeScanner
          titolo={titolo}
          formati={formati}
          onChiudi={() => setAperto(false)}
          onRilevato={(codice) => {
            setAperto(false);
            onRilevato(codice);
          }}
        />,
        document.body,
      )}
    </>
  );
};

export default PulsanteScanner;
